import LongArrowRightIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/long-arrow-right';

import AMENITY_TYPE_MAP from '@shared/ui/amenity-types-map';

export const getSmAmenityIcon = (type: string) =>
  AMENITY_TYPE_MAP[`${type}--sm`] ?? LongArrowRightIcon;

export const getAmenityIcon = (type: string) =>
  AMENITY_TYPE_MAP[type] ?? LongArrowRightIcon;
